<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Interconsultas</h4>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;" @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp" title="Ayuda">
      <AyudaInterconsulta />
    </Modal>
    <hr>
<!-- Master -->
<div class="modal-dialog modal-xl" style="z-index: 1;">
    <div class="modal-content">
      <b>Datos del Médico</b>
      <form>
        <div class="modal-body">
            <div class="mb-3">
                <div class="row">
                  <div class="col-5">
                    <label for="nombreCompleto" class="form-label">Nombre</label>
                    <input type="text" class="form-control" id="nombreCompleto" name="nombreCompleto" v-model="datoMedico.nombreCompleto" disabled>
                  </div>
                  <div class="col-5">
                    <label for="especialidadNombre" class="form-label"> Especialidad</label>
                    <input type="text" class="form-control" id="especialidadNombre" name="especialidadNombre" v-model="datoMedico.especialidadNombre" disabled>
                  </div>
                  <div class="col-2">
                    <label for="documento" class="form-label">Documento</label>
                    <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' disabled>
                  </div>
                </div>
            </div>
          </div>
      </form>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-hover" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Paciente</th>
          <th scope="col">Médico</th>
          <th scope="col">Cuadro</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interconsulta in datosPaginados" :key="interconsulta.idInterconsulta" @click="handleRowClick($event, interconsulta.idInterconsulta)">
          <td>{{interconsulta.paciente}}</td>
          <td>{{interconsulta.medicoAtencion}}</td>
          <td>{{interconsulta.cuadro}}</td>
          <td>
            <select class="form-select" @change="handleAction($event, interconsulta.idInterconsulta)">
              <option disabled selected>Seleccione...</option>
              <option value="editar">Editar</option>
              <option value="detalles">Detalles</option>
              <option value="formulario">Formulario informe</option>
              <option value="borrar">Borrar</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example" v-if="!popupAyuda">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="atencion" name="atencion" v-model="datoInterconsulta.atencion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAtencionLOV"
                      title="Buscar Diagnósticos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoInterconsulta.idMedico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoInterconsulta.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Interconsulta -->
    <InterconsultaLOVdet @DatosInterconsulta="GetDataInterconsultaLOVdet($event)"/>
<!-- Lista de Valores: Atencion -->
    <AtencionLOVdet @DatosAtencion="GetDataAtencionLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaInterconsulta from '@/views/ayuda/AyudaInterconsulta.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores details
import InterconsultaLOVdet from '../../components/lovs/InterconsultaLOV.vue'
import AtencionLOVdet from '../../components/lovs/AtencionLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer, AyudaInterconsulta
// Listas de valores details
, InterconsultaLOVdet
, AtencionLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      medicos : [],
      datoMedico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMedico: '',
// Variables master
popupAyuda: false,
// Variables details
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMedico = this.$route.params.p_idmedico
    this.abrirEditar(this.p_idMedico)
    this.getInterconsultas()
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()    
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    handleAction(event, idInterconsulta) {
      const action = event.target.value;
      if (action === 'editar') {
        this.abrirModalEditar(idInterconsulta);
      } else if (action === 'detalles') {
        this.abrirEditarDet(idInterconsulta);
      } else if (action === 'formulario') {
        this.formulario007informePDF(idInterconsulta);
      } else if (action === 'borrar') {
        this.deletePersona(idInterconsulta);
      }
      // Restablecer el valor del select a su estado predeterminado
      event.target.value = 'Seleccione...';
    },
    handleRowClick(event, idInterconsulta) {
      if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') {
        return;
      }
      this.abrirModalEditar(idInterconsulta);
    },
// Procedimientos master
    validarForm(){
      if(this.datoMedico.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear Médico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMedico){
      this.modalWindow = true
      if(idMedico != null){    
           api.get('/vwmedicos/'+idMedico).then(resp=>{
          this.datoMedico = resp.data;
           });
      }
      this.titulo   = 'Editar Médico'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMedico(){
      this.$router.push('/Medico')
    },
// Procedimientos master
// Procedimientos detalle
    async getInterconsultas() {
      const resp = await api.get('/interconsultas')
      this.interconsultas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.interconsultas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwinterconsultas/nombre/'+this.nombreBusqueda).then(response=>{
          this.interconsultas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.interconsultas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwinterconsultas/idmedico/'+this.p_idMedico).then(response=>{
      this.interconsultas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.interconsultas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoInterconsulta.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarInterconsulta(){
      if(this.validarForm() === 1){
        try {
          this.datoInterconsulta.idMedico = this.datoMedico.idMedico;
          await api.post('/interconsultas', this.datoInterconsulta)
          this.getInterconsultas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Interconsulta creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Interconsulta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalEditar(idInterconsulta){
      this.modalWindow = true
      if(idInterconsulta != null){    
           api.get('/vwinterconsultas/'+idInterconsulta).then(resp=>{
          this.datoInterconsulta = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Médico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idInterconsulta){
      this.modalWindow = true
      if(idInterconsulta != null){
        this.$router.push('/interconsultaform/2/'+idInterconsulta)
      }
    },
    async deleteInterconsulta (idInterconsulta) {
      try{
        await api.delete('/interconsultas/'+idInterconsulta)
          this.getInterconsultas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    formulario007informePDF(idInterconsulta) {
      const url = 'http://localhost:8080/api/v1/reportes/pdf/4/' + idInterconsulta;
      window.open(url, '_blank');
    },  
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
// Procedimientos detalle
// Listas de valores details
//    Lista de Valores
    GetDataInterconsultaLOVdet(data) {
      this.datoInterconsulta.idInterconsulta = data.idInterconsulta;
      this.datoInterconsulta.interconsulta = data.nombre;
    },
//    Lista de Valores
    GetDataAtencionLOVdet(data) {
      this.datoInterconsulta.idAtencion = data.idAtencion;
      this.datoInterconsulta.atencion = data.nombre;
    },
// Listas de valores details
  },
}
</script>
<style scoped>
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
  /* o cualquier otro color de fondo que prefieras */
  cursor: pointer;
  /* Cambia el cursor a una mano */
}
</style>
